import { WFComponent } from "@xatom/core";
import { API_ENDPOINT, CATEGORY_STRIPE_MAPPING, CLIENT_URL } from "../../config";
import axios from "axios";

export const searchBar = () => {
    const token = localStorage.getItem("_ms-mid");
    document.addEventListener(
        "search-loaded",
        (e) => {
            try {
                const list = new WFComponent(`#search-terms`);
                const unlockButtons = list.getChildAsComponents(`[xa-type="unlock-btn"]`);
                unlockButtons.forEach((ub) => {
                    ub.on("click", async (e) => {
                        const name = ub.getAttribute("xa-name");
                        const category = CATEGORY_STRIPE_MAPPING.find((m) => m.name === name);
                        let mainUnlockButton = null;
                        const popupList = new WFComponent(`.search-wrapper`);
                        setTimeout(() => {
                            mainUnlockButton = popupList.getChildAsComponent(`[data-payment-name="${name}"]`).getChildAsComponent(`[xa-type="data-payment-link"]`);
                            mainUnlockButton.setText("Please wait...");
                        }, 100);
                        const user = await axios.get(`${API_ENDPOINT}/airtable/user`, { headers: { authorization: `Bearer ${token}` } });
                        const stripeCustomerId = user.data.data.fields.stripe_customer_id;
                        const result = await axios.post(`${API_ENDPOINT}/webhook/checkout`, {
                            priceId: category.priceId,
                            success_url: `${CLIENT_URL}/?categoryunlocked=${category.name.replace(" ", "")}`,
                            cancel_url: `${CLIENT_URL}`,
                            customer: stripeCustomerId,
                            metadata: { Category: category.name }
                        });
                        console.log(result.data.url);
                        mainUnlockButton.setAttribute("href", result.data.url);
                        mainUnlockButton.setText("Unlock Now");
                        mainUnlockButton.removeCssClass("is-disabled");
                    });
                });
            } catch (error) {
                console.log("Error in search-loaded event:", error);
            }
        },
        false,
    );
};